<div>
    <div class="text-center">
        <h3>Zoeken</h3>
    </div>
    <div class="row">
        <div class="xl:col-6 lg:col-6 col-12">
            <search-component [overlayOptions]="{ mode: 'overlay' }"></search-component>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
        </div>
    </div>
</div>